import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setTreatmentContinuation } from '../../redux/userSlice';
import Question from "../../components/Question";
import MoveButton from "../../components/MoveButton";
import { Stack, Box, Typography, useMediaQuery, useTheme, Collapse } from "@mui/material";
import ContinueButton from '../../components/ContinueButton';
import { continueButtonSx } from '../../lib/uiformatting';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function TreatmentContinuation() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const user = useSelector((state) => state.user);

    const [continueTreatment, setContinueTreatment] = useState(
        user.treatmentContinuation?.continueTreatment || ''
    );
    const [interestedInAccutane, setInterestedInAccutane] = useState(
        user.treatmentContinuation?.interestedInAccutane || ''
    );

    const hasAccutane = user.prescriptions?.some((med) =>
        med.name.toLowerCase().includes('accutane') ||
        med.name.toLowerCase().includes('isotretinoin')
    );

    const handleContinueTreatment = (value) => {
        setContinueTreatment(value);

        if (value === "N") {
            setInterestedInAccutane('');
            return;
        }

        if (hasAccutane) {
            setInterestedInAccutane("Y");
        } else {
            setInterestedInAccutane("N");
        }
    };

    const handleAccutaneInterest = (value) => {
        setInterestedInAccutane(value);
        dispatch(setTreatmentContinuation({
            continueTreatment,
            interestedInAccutane: value,
        }));

        if (value === 'Y' && (user.address.state === 'CT' || user.address.state === 'MA')) {
            setPageAndDeferNavigate(dispatch, '/patient-history-medical', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/duration', navigate);
        }
    };

    const handleNext = () => {
        dispatch(setTreatmentContinuation({
            continueTreatment,
            interestedInAccutane
        }));

        if (continueTreatment === 'Y') {
            if (hasAccutane && (user.address.state === 'CT' || user.address.state === 'MA')) {
                setPageAndDeferNavigate(dispatch, '/patient-history-medical', navigate);
            } else {
                setPageAndDeferNavigate(dispatch, '/duration', navigate);
            }
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/prescriptions', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            title="Would you like to continue with your current medications?"
            input={
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                >
                    <Stack
                        spacing={2}
                        width="100%"
                        maxWidth={isDesktop ? "400px" : "100%"}
                        alignItems="center"
                    >
                        <MoveButton
                            sx={{ width: '100%', maxWidth: '400px' }}
                            onClick={() => handleContinueTreatment('Y')}
                            title="Yes"
                            selected={continueTreatment === 'Y'}
                        />
                        <MoveButton
                            sx={{ width: '100%', maxWidth: '400px' }}
                            onClick={() => handleContinueTreatment('N')}
                            title="No"
                            selected={continueTreatment === 'N'}
                        />
                    </Stack>

                    <Collapse
                        in={continueTreatment === 'N'}
                        mountOnEnter
                        unmountOnExit
                    >
                        <Box
                            sx={{
                                width: "100%",
                                mt: "2rem",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{ mb: "1rem", textAlign: "start" }}
                            >
                                Are you interested in starting Accutane/Isotretinoin?
                            </Typography>

                            <Stack
                                spacing={2}
                                width="100%"
                                maxWidth={isDesktop ? "400px" : "100%"}
                                alignItems="center"
                            >
                                <MoveButton
                                    sx={{ width: '100%', maxWidth: '400px' }}
                                    onClick={() => handleAccutaneInterest('Y')}
                                    title="Yes"
                                    selected={interestedInAccutane === 'Y'}
                                />
                                <MoveButton
                                    sx={{ width: '100%', maxWidth: '400px' }}
                                    onClick={() => handleAccutaneInterest('N')}
                                    title="No"
                                    selected={interestedInAccutane === 'N'}
                                />
                            </Stack>
                        </Box>
                    </Collapse>
                </Box>
            }
            footer={
                continueTreatment === 'Y' && (
                    <Box
                        sx={{ ...continueButtonSx }}
                    >
                        <ContinueButton
                            onClick={handleNext}
                            title="Continue"
                            selected={true}
                        />
                    </Box>
                )
            }
        />
    );
}
